import { animated } from '@react-spring/web';
import React, { FunctionComponent } from 'react';
import { Fade } from '../../animation/Fade/Fade';
import { prepareProps } from '../../utils/propUtils';
import { Spinner } from '../Spinner/Spinner';
import styles from './LoadingOverlay.module.css';

export type LoadingOverlayProps = {
  active: boolean;
};

export const LoadingOverlay: FunctionComponent<LoadingOverlayProps> =
  React.memo((props) => {
    const { active, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    return (
      <Fade show={active}>
        {(style) => (
          <animated.div
            {...remainingProps}
            className={styles.backdrop}
            style={style}
          >
            <Spinner className={styles.spinnerWrapper}></Spinner>
          </animated.div>
        )}
      </Fade>
    );
  });
